import React from "react";
import { useSnackbar } from 'notistack';
import { Button } from "@material-ui/core";

export const withToast = WrappedComponent => {
  return props => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();


    const showSuccess = (message) => {
      enqueueSnackbar(message, { variant: "success" })
    };

    const showSuccessPerm = (message) => {
      enqueueSnackbar(message, {
        variant: "success",
        style: { whiteSpace: 'pre-line' },
        persist: true,
        action: key => (
          <Button onClick={() => closeSnackbar(key)}>X</Button>
        )
      })
    };

    const showError = (message) => {
      enqueueSnackbar(message, {
        variant: "error",
        style: { whiteSpace: 'pre-line' },
        persist: true,
        action: key => (
          <Button onClick={() => closeSnackbar(key)}>X</Button>
        )
      })
    };

    return (
      <WrappedComponent {...props} successToast={showSuccess} successToastPersist={showSuccessPerm} errorToast={showError} />
    );
  };
};
